"use strict";

angular.module("vendor")
.component("industryFilter", {
    bindings: {
        sharedScope: "="
    },
    templateUrl: require("./industry-filter.component.html"),
    controllerAs: "industryFilterCtrl",
    controller: function($scope, $filter, $state, $stateParams, IndustryService, StateExtensionService) {
        $scope.selectedIndustries = [];

        this.removeFilter = function(industryId) {
            var industryToRemove = $filter("filter")($scope.selectedIndustries, {id: industryId}, true)[0];
            if (industryToRemove) {
                var industryIndex = $scope.selectedIndustries.indexOf(industryToRemove);
                if (industryIndex !== -1) {
                    $scope.selectedIndustries.splice(industryIndex, 1);
                    var industryIds = IndustryService.getFilterIdParameter($scope.selectedIndustries);
                    if (!industryIds) industryIds = null;
                    this.sharedScope.$emit("industryFilterUpdated", {industries: industryIds});
                }
            }
        };

        this.clearAll = function() {
            $scope.selectedIndustries = [];
            this.sharedScope.$emit("industryFilterUpdated", {industries: null});
        };

        this.sharedScope.$on("industryFilterUpdated", function(event, industriesFilter) {
            StateExtensionService.updateUrlParams(industriesFilter);
        });

        if($stateParams.industries) {
            IndustryService.getSelectedIndustries($stateParams.industries.split(",")).then(function onSuccess(industries) {
                $scope.selectedIndustries = industries;
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/industry-filter/industry-filter.component.js
// module id = 811
// module chunks = 0